<template>
    <section class="search-market-trends" v-if="marketTrendsSummary && marketTrendsSummary.length">
        <div class="grid xs-grid-cols-1">
            <h2 class="f4 text-bold">{{getGeoDisplayText}} real estate market trends</h2>
            <div class="f7 text-gray">Statistics as of {{currentDate.toLocaleString('en-US', { month: 'long' })}} {{currentDate.getFullYear()}}</div>
            <div class="stat-cards">
                <article class="stat-card" v-for="(item, i) in marketTrendsSummary" :key="i">
                    <i class="f3" :class="item.icon"></i>
                    <div class="f3">{{item.value}}</div>
                    <div class="f7">{{ item.key }}</div>
                </article>
            </div>
            <div class="m-y-1">
                Movoto makes it easy to track market trends in {{ getGeoDisplayText }}.  Whether you’re entering the market or planning your next move, understanding these key metrics can guide smart decisions.  <a v-if="glb.geo?.marketTrendsPath" :href='`${glb.appUrl}${glb.geo.marketTrendsPath}`' class="link">Looking for more detailed housing market stats in {{ getGeoDisplayText }}?</a>
            </div>
        </div>
    </section>
</template>

<script src="./market-trends.js"></script>

<style lang="scss">
@use "./market-trends.scss" as *;
</style>
